var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('ProjectOverviewBody',[_c('ProjectOverview',{attrs:{"title":"My Website","description":"With a will to explore WEB developement and to craft my own website, I went on building my portfolio. With VueJS, I achieved to make it modular so I can easely add/remove/modify content and thanks to Bootstrap the website is responsive.","timeline":"August - September 2020","team":"Alone","image":"website/Website_Logo.png","tags":['WEB', 'HTML/CSS', 'VueJS', 'Bootstrap'],"keypoints":[
          'Easely add/remove content with VueJS',
          'Responsive',
          'Learned a lot about WEB developpement'
      ],"categories":[
          'WEB',
          'WEB',
          'WEB'
      ]}}),_c('ProjectOverviewCarrousel',{staticStyle:{"margin":"100px auto 100px auto"},attrs:{"images":[
          'website/Website_Screenshot_2.jpg',
          'website/Website_Screenshot_3.jpg'
      ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }